import { Link } from 'react-router-dom';
import { channels } from '@/mocks/gossip';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="w-full border-t border-background-200 bg-background-100">
      <div className="mx-auto grid max-w-6xl gap-10 px-4 py-12 md:grid-cols-4 md:px-6">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2">
            <span className="grid h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-lg text-background-50">
              <i className="ri-news-line"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-black text-foreground-900">吃瓜日报</span>
              <span className="mt-0.5 text-[10px] tracking-[0.18em] text-primary-600">DAILY GOSSIP</span>
            </span>
          </div>
          <p className="mt-4 text-sm leading-6 text-foreground-600">
            每日更新，汇集当日最新瓜料与热门事件。点开即看，今天发生了什么、谁又翻车了，一分钟速览不漏新瓜。
          </p>
        </div>

        <div>
          <h4 className="mb-3 font-heading text-sm font-bold text-foreground-900">内容频道</h4>
          <ul className="space-y-2.5">
            {channels.map((c) => (
              <li key={c.key}>
                <Link to={`/channel/${c.key}`} className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                  {c.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-3 font-heading text-sm font-bold text-foreground-900">快速导航</h4>
          <ul className="space-y-2.5">
            <li><Link to="/" className="text-sm text-foreground-600 hover:text-primary-700">首页速览</Link></li>
            <li><Link to="/daily" className="text-sm text-foreground-600 hover:text-primary-700">每日合集</Link></li>
            <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-700">关于我们</Link></li>
            <li><Link to="/about#principles" className="text-sm text-foreground-600 hover:text-primary-700">内容原则</Link></li>
            <li><Link to="/about#contact" className="text-sm text-foreground-600 hover:text-primary-700">投稿与联系</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="mb-3 font-heading text-sm font-bold text-foreground-900">关注我们</h4>
          <p className="mb-4 text-sm leading-6 text-foreground-600">
            随手转发一个瓜，是最快支持我们的方式。欢迎到站内留下你的看法。
          </p>
          <div className="flex items-center gap-2">
            {['ri-wechat-line', 'ri-weibo-line', 'ri-rss-line'].map((ic) => (
              <a
                key={ic}
                href="#about"
                className="grid h-10 w-10 items-center justify-center rounded-full bg-background-200 text-base text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
                aria-label="社交入口"
              >
                <i className={ic}></i>
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-foreground-500 sm:flex-row md:px-6">
          <p>© {year} 吃瓜日报 · 内容仅供参考，以官方公开信息为准</p>
          <p>本站为娱乐资讯整理站点 · 联系邮箱 hello@chiguadaily.example</p>
        </div>
      </div>
    </footer>
  );
}